<template>
  <Loading v-if="loading" />
  <Block v-else>
    <div class="px-6 py-4 flex items-center justify-between">
      <div class="flex items-center gap-3">
        <span class="text-xl">🔧</span>
        <div>
          <span class="text-xs font-semibold uppercase tracking-wide text-gray-400">Sinistres à traiter</span>
          <p class="text-base font-bold text-gray-900">
            {{ pendingCount }} {{ pendingCount <= 1 ? "dossier" : "dossiers" }} en attente
          </p>
        </div>
      </div>
      <router-link
        v-if="pendingCount > 0"
        :to="claimsRoute"
        class="inline-flex items-center gap-2 rounded-2xl bg-gray-900 px-4 py-2 text-sm font-semibold text-white hover:bg-gray-800 transition-colors whitespace-nowrap"
      >
        Voir
        <ArrowRightIcon class="h-4 w-4" />
      </router-link>
    </div>
  </Block>
</template>

<script>
import { Block, Loading } from "@estaly/ui";
import { ArrowRightIcon } from "@heroicons/vue/solid";
import { mapGetters, mapState, mapActions } from "vuex";

export default {
  components: {
    Block,
    Loading,
    ArrowRightIcon,
  },
  props: {
    claimsRoute: {
      type: String,
      default: "/pos/claims?tab=action-required",
    },
    storeChannels: {
      type: Array,
      default: null,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapGetters("store", ["selectedStore"]),
    ...mapState("claims", ["pendingCount"]),
  },
  methods: {
    ...mapActions("claims", ["fetchPendingCount"]),
    async fetchPendingClaims(stores) {
      this.loading = true;
      try {
        await this.fetchPendingCount({ stores });
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    if (this.storeChannels != null) {
      this.fetchPendingClaims(this.storeChannels);
    }
  },
  watch: {
    selectedStore: {
      handler(store) {
        if (this.storeChannels != null) return;
        if (store) this.fetchPendingClaims([store.salesChannel]);
      },
      immediate: true,
    },
  },
};
</script>
